import { createRootRoute, HeadContent, Outlet } from "@tanstack/react-router";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { ThemeProvider } from "@/components/theme-provider";
import { ConvexClientProvider } from "@/components/convex-client-provider";
import { RootError } from "@/components/root-error";
import { NotFound } from "@/components/not-found";
import "@/globals.css";

// Was src/app/layout.tsx. The <html>/<body> shell lives in index.html now —
// there is no server render, so React never owns those tags. The theme script
// that next-themes relied on Next to inline is in index.html too.
export const Route = createRootRoute({
  component: RootLayout,
  // Mirrors the old global-error.tsx: this renders *outside* RootLayout, so
  // it has no ThemeProvider and no Convex client. Keep it provider-free.
  errorComponent: RootError,
  notFoundComponent: NotFound,
  head: () => ({
    meta: [
      { title: "Veez HQ" },
      { name: "description", content: "Veez sales & customer operations" },
    ],
  }),
});

function RootLayout() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <ConvexClientProvider>
        {/* Inside the router provider — the nuqs tanstack-router adapter
            reads useRouter()/useRouterState(). */}
        <NuqsAdapter>
          <HeadContent />
          <Outlet />
        </NuqsAdapter>
      </ConvexClientProvider>
    </ThemeProvider>
  );
}
